import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=7207c184&scoped=true&"
import script from "./checkbox.js?vue&type=script&lang=js&"
export * from "./checkbox.js?vue&type=script&lang=js&"
import style0 from "./checkbox.scss?vue&type=style&index=0&id=7207c184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7207c184",
  null
  
)

export default component.exports